let parent = document.querySelector(".process-animation");
import gsap from "gsap";
class Process {
  constructor() {
    this.parent = document.querySelector(".process-animation__canvas");
    this.width = this.parent.clientWidth;
    this.height = this.parent.clientHeight;
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
    this.parent.appendChild(this.canvas);
    this.ratio = window.devicePixelRatio;
    this.padding = 30;
    this.activeColor = "215, 255, 189";

    this.canvas.width = 2 * this.width;
    this.canvas.height = 2 * (this.height + this.padding * 2);

    this.canvas.style.width = this.width + "px";
    this.canvas.style.height = this.height + this.padding * 2 + "px";

    this.canvas.style.top = -this.padding + "px";
    this.canvas.style.left = 0;

    if (window.isMobile) {
      this.canvas.width = 2 * this.height;
      this.canvas.height = 2 * (this.width + this.padding * 2);

      this.canvas.style.width = this.height + "px";
      this.canvas.style.height = this.width + this.padding * 2 + "px";
      this.canvas.style.left = -this.padding + "px";
      // this.canvas.style.top = 0;
    }

    this.currentActiveTitle = -1;

    this.drawCircles();
    this.buildCurve();
    this.drawCurve();
    if (!window.isMobile) this.scrollFixedSections();

    if (!window.isMobile) {
      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".process-animation",
          start: "top 20%",
          end: "+=3000",
          scrub: true,
          pin: true,
        },
      });
    } else {
      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".process-animation",
          start: "top 60%",
          end: "bottom 100%",
          scrub: true,
        },
      });
    }

    let o = { p: 0 };
    this.tl.to(o, {
      p: 1,
      duration: 5,
      ease: "none",
      onUpdate: () => {
        // console.log(o.p)
        this.drawProgress(o.p);
      },
    });
  }

  scrollFixedSections() {
    let sections = [...document.querySelectorAll(".psec")];
    let titles = sections.map((el) => el.querySelector(".psec__title"));
    sections.forEach((section, i) => {
      gsap.to(section, {
        scrollTrigger: {
          trigger: section,
          start: "top 50%",
          end: "bottom 50%",
          toggleActions: "play reverse play reverse",
          onEnter: () => {
            console.log("enter" + i, titles[i].innerText);
            this.activateTitle(titles[i], i);
          },
          onEnterBack: () => {
            console.log("enter back" + i, titles[i].innerText);
            this.activateTitle(titles[i], i);
          },
          onLeave: () => {
            console.log("leave" + i);
          },
          scrub: true,
          // pin: true,
        },
      });
    });
  }

  activateTitle(title, i) {
    if (this.currentActiveTitle == i) return;
    this.currentActiveTitle = i;
    let fill = document.querySelector(".steps-center__title");
    let tl = gsap.timeline();
    tl.to(fill, {
      duration: 1,
      y: "150%",
      ease: "power4.out",
      rotation: 20,
      transformOrigin: "0 50%",
      onComplete: () => {
        fill.innerText = title.innerText;
      },
    });
    tl.fromTo(
      fill,
      {
        y: "150%",
        rotation: 20,
      },
      {
        duration: 1,
        y: 0,
        rotation: 0,
        transformOrigin: "0 50%",
        immediateRender: false,
        ease: "power4.out",
      }
    );
  }

  drawCircles() {
    this.ctx.strokeStyle = "rgba(255,255,255,0.5)";
    this.ctx.lineWidth = 1 * this.ratio;
    this.r = (this.ratio * this.height) / 2;
    if (window.isMobile) this.r = (this.ratio * this.width) / 2;
    this.circleR = this.r - this.ctx.lineWidth;

    this.centers = [
      {
        x: this.r,
        y: this.r + this.padding * this.ratio,
      },
      {
        x: (this.ratio * this.width) / 2,
        y: this.r + this.padding * this.ratio,
      },
      {
        x: this.ratio * this.width - this.r,
        y: this.r + this.padding * this.ratio,
      },
    ];
    if (window.isMobile) {
      this.centers = [
        {
          x: this.r,
          y: this.r + this.padding * this.ratio,
        },
        {
          x: (this.ratio * this.height) / 2,
          y: this.r + this.padding * this.ratio,
        },
        {
          x: this.ratio * this.height - this.r,
          y: this.r + this.padding * this.ratio,
        },
      ];
    }

    this.centers.forEach((center) => {
      this.ctx.beginPath();
      this.ctx.arc(center.x, center.y, this.circleR, 0, 2 * Math.PI);
      this.ctx.closePath();
      this.ctx.stroke();
    });
  }

  buildCurve() {
    this.curve = [];

    let offset = 0.535;
    let detail = 0.01;
    let angle = -Math.PI;
    let center = this.centers[0];
    let r = this.circleR;
    while (angle < offset) {
      let x = center.x + r * Math.cos(angle);
      let y = center.y + r * Math.sin(angle);
      this.curve.push({ x, y });
      angle += detail;
    }
    center = this.centers[1];
    angle = Math.PI - offset;

    while (angle > -offset) {
      let x = center.x + r * Math.cos(angle);
      let y = center.y + r * Math.sin(angle);
      this.curve.push({ x, y });
      angle -= detail;
    }

    center = this.centers[2];
    angle = -Math.PI + offset;

    while (angle < -0.4) {
      let x = center.x + r * Math.cos(angle);
      let y = center.y + r * Math.sin(angle);
      this.curve.push({ x, y });
      angle += detail;
    }
  }

  drawCurve(index) {
    // debug only

    this.ctx.lineWidth = 3 * this.ratio;
    // this.ctx.beginPath();
    console.log(this.curve.length);
    let lastpoints = 150;
    for (let i = 0; i < this.curve.length - 1; i++) {
      if (i < index && i > index - lastpoints) {
        let opacity = 1 - (index - i) / lastpoints;
        this.ctx.strokeStyle = `rgba(${this.activeColor},${opacity})`;

        this.ctx.beginPath();
        let p = this.curve[i];
        let p1 = this.curve[i + 1];
        this.ctx.moveTo(p.x, p.y);
        this.ctx.lineTo(p1.x, p1.y);
        this.ctx.closePath();
        this.ctx.stroke();
      }
    }
    // this.ctx.closePath()
  }

  drawProgress(progress) {
    if(window.isMobile){
        this.ctx.clearRect(
            0,
            0,
            this.ratio * this.height,
            this.ratio * (this.width + this.padding * 2)
          );
    } else{
        this.ctx.clearRect(
            0,
            0,
            this.ratio * this.width,
            this.ratio * (this.height + this.padding * 2)
          );
    }
    
    this.drawCircles();
    let curIndex = Math.floor(progress * this.curve.length - 0.1);
    let curpoint = this.curve[curIndex];
    let prevPoint = this.curve[Math.max(0, curIndex - 1)];
    let angle = Math.atan2(curpoint.y - prevPoint.y, curpoint.x - prevPoint.x);
    // curpoint = clamp(0,)
    this.ctx.fillStyle = "rgba(255,0,0,1)";
    this.ctx.save();
    this.drawCurve(curIndex);
    this.ctx.translate(curpoint.x, curpoint.y);
    this.ctx.rotate(angle);
    // this.ctx.fillRect(0,0, 100, 10)
    this.ctx.fillStyle = `rgb(${this.activeColor})`;
    this.ctx.beginPath();
    this.ctx.moveTo(0, 20);
    this.ctx.lineTo(0, -20);
    this.ctx.lineTo(30, 0);
    this.ctx.closePath();
    this.ctx.fill();
    this.ctx.restore();
  }
}

if (parent) new Process();
